import * as React from 'react';
import { config } from '../../config';
import * as vars from '../../consts/variables';
import { __ } from '../../helpers/TranslationService';
import { validateDDD, validatePhone } from '../../helpers/validation';
import { CountryCodeSelect } from './CountryCodeSelect';
import { Input } from './Input';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        margin: '0 15px 0 0',
    },
    phoneSection: {
        display: 'flex',
    },
    countryCode: {
        flex: 1,
    },
    ddd: {
        flex: 1,
    },
    phone: {
        flex: 2,
    },
    inputWrapper: {
        marginRight: 0,
    },
    errorText: {
        fontSize: 14,
        color: vars.pink,
        marginTop: -15,
        marginBottom: 15,
        marginLeft: 15,
    },
};

interface IProps {
    placeholder: string;
    phoneNumber: string;
    countryCode: string;
    countryCodes: { code: string; label: string; country: string; countryCode: string }[];
    ddd: string;
    isSubmitted: boolean;
    onPhoneChange(event: React.ChangeEvent<any>): void;
    onDDDChange(event: React.ChangeEvent<any>): void;
    onCountryCodeChange(value: string): void;
    portalId: string;
    firstInvalidFormField: string;
    testSelectorName?: string;
}

export class PhoneSelection extends React.Component<IProps, {}> {
    onCountryCodeChange = (selected: { value: string; label: string }) => {
        this.props.onCountryCodeChange(selected.value);
    };

    getOptionsForCountryCodeSelect = () =>
        this.props.countryCodes.map((item) => ({
            value: item.code,
            label: item.label,
            icon: item.countryCode ? `${config.images}/common/flags/${item.countryCode}.svg` : null,
        }));

    getMaskByCountry = (portalId, countryCode) => {
        if (portalId === 'dreamlines.com' && countryCode === '+1') {
            return [
                /[0-9]/,
                ' ',
                /[0-9]/,
                ' ',
                /[0-9]/,
                ' ',
                '-',
                ' ',
                /[0-9]/,
                ' ',
                /[0-9]/,
                ' ',
                /[0-9]/,
                ' ',
                '-',
                ' ',
                /[0-9]/,
                ' ',
                /[0-9]/,
                ' ',
                /[0-9]/,
                ' ',
                /[0-9]/,
            ];
        }
        return '';
    };

    render() {
        const {
            isSubmitted,
            phoneNumber,
            onPhoneChange,
            ddd,
            onDDDChange,
            countryCode,
            portalId,
            firstInvalidFormField,
        } = this.props;
        const options = this.getOptionsForCountryCodeSelect();
        const isCountryCodeError = isSubmitted && this.props.countryCode.length === 0;
        const countryCodeOptions = {
            onChange: this.onCountryCodeChange,
            options: options,
            value: options.find((item) => item.value === this.props.countryCode),
            placeholder: __('mobile.personalData.countryCode', 'dreamlines'),
            isError: isCountryCodeError,
            testSelectorName: 'countrySelect',
        };
        const isPhoneError = isSubmitted && !validatePhone(phoneNumber);
        const phoneProps = {
            placeholder: this.props.placeholder,
            value: phoneNumber,
            onChange: onPhoneChange,
            isError: isPhoneError,
            wrapperStyle: styles.inputWrapper,
            isFirstInvalidFormField: firstInvalidFormField === 'phoneNumber',
            type: 'tel',
            testSelectorName: 'phoneNumber',
            mask: this.getMaskByCountry(portalId, countryCode),
            maskPlaceholder: '_ _ _ - _ _ _ - _ _ _ _',
        };
        const isDDDError = isSubmitted && !validateDDD(ddd);
        const dddProps = {
            placeholder: __('personalData.DDD', 'dreamlines'),
            value: ddd,
            onChange: onDDDChange,
            isError: isDDDError,
            wrapperStyle: styles.inputWrapper,
            isFirstInvalidFormField: firstInvalidFormField === 'DDD',
            testSelectorName: 'ddd',
        };
        const isError = isCountryCodeError || isPhoneError;
        const isDDDShown =
            countryCode === vars.brasilCountryCode ||
            (countryCode === '' && portalId === 'dreamlines.com.br');
        return (
            <div style={styles.wrapper}>
                <div style={styles.phoneSection}>
                    <div style={styles.countryCode}>
                        <CountryCodeSelect {...countryCodeOptions} />
                    </div>
                    {isDDDShown && (
                        <div style={styles.ddd}>
                            <Input {...dddProps} />
                        </div>
                    )}
                    <div style={styles.phone}>
                        <Input {...phoneProps} testSelectorName={this.props.testSelectorName} />
                    </div>
                </div>
                <div style={styles.errorText}>{isError && __('errors.phone', 'dreamlines')}</div>
            </div>
        );
    }
}
